import ApiClient from './ApiClient';

class CountriesAPI extends ApiClient {
  constructor() {
    super('countries', { accountScoped: true });
  }
}

export default new CountriesAPI();
